import { withConfig } from "@/utils/withConfig";
import { DonationIntent } from "./DonationIntent";
import type { DonationIntentProps } from "./DonationIntentProps";

export * from "./DonationIntent";
export * from "./DonationIntentProps";

export const DonationIntentWithConfig = withConfig<DonationIntentProps>(
  DonationIntent,
  "donation_intent",
);
